(() => {
  if (window.__figCartConfirmationInstalled) return;

  const init = () => {
    const notification = document.getElementById('FigCartConfirmation');
    if (!notification || window.__figCartConfirmationInstalled) return;

    window.__figCartConfirmationInstalled = true;

    const productElement = notification.querySelector('.fig-cart-notification__product');
    const imageElement = notification.querySelector('[data-fig-cart-image]');
    const imageWrap = notification.querySelector('[data-fig-cart-image-wrap]');
    const titleElement = notification.querySelector('[data-fig-cart-title]');
    const variantElement = notification.querySelector('[data-fig-cart-variant]');
    const quantityElement = notification.querySelector('[data-fig-cart-quantity]');
    const priceElement = notification.querySelector('[data-fig-cart-price]');
    const totalElement = notification.querySelector('[data-fig-cart-total]');
    const summaryElement = notification.querySelector('[data-fig-cart-summary]');
    const timerElement = notification.querySelector('[data-fig-cart-timer]');
    const cartLink = notification.querySelector('.fig-cart-notification__cart-link');
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = `${root}cart`;
    const AUTO_CLOSE_MS = 7000;

    let closeTimer = null;
    let lastSignature = '';
    let lastOpenTime = 0;
    let lastTouchTime = 0;

    const formatMoney = (cents) => {
      if (typeof cents !== 'number') return '';
      return new Intl.NumberFormat('ro-RO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' lei';
    };

    const normalizeImageUrl = (value) => {
      let url = value;
      if (url && typeof url === 'object') url = url.url || url.src || '';
      if (!url) return '';
      return url.startsWith('//') ? `https:${url}` : url;
    };

    const getAddedItem = (data) => {
      if (!data) return null;
      if (Array.isArray(data.items) && data.items.length) return data.items[data.items.length - 1];
      return data.product_title || data.title || data.variant_title ? data : null;
    };

    const getCart = async () => {
      try {
        const response = await fetch(`${cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        return response.ok ? response.json() : null;
      } catch (error) {
        return null;
      }
    };

    const findAddedItem = (cart, variantId, productId) => {
      if (!cart || !Array.isArray(cart.items)) return null;

      const normalizedVariantId = variantId ? String(variantId) : '';
      const normalizedProductId = productId ? String(productId) : '';

      if (normalizedVariantId) {
        const variantMatch = cart.items.find((item) =>
          String(item.variant_id || item.id || '') === normalizedVariantId
        );
        if (variantMatch) return variantMatch;
      }

      if (normalizedProductId) {
        return cart.items.find((item) => String(item.product_id || '') === normalizedProductId) || null;
      }

      return cart.items[0] || null;
    };

    const setPosition = () => {
      const isMobile = matchMedia('(max-width: 749px)').matches;
      const viewportOffset = isMobile && window.visualViewport
        ? Math.max(0, Math.round(window.visualViewport.offsetTop || 0))
        : 0;

      notification.style.setProperty('--fig-cart-top', isMobile ? `${viewportOffset + 14}px` : '82px');
      notification.style.setProperty(
        '--fig-cart-right',
        isMobile ? '14px' : 'max(28px, calc((100vw - 1400px) / 2 + 20px))'
      );
    };

    /* Închiderea este intenționat sincronă. Unele WebView-uri Android pot
       întârzia timer-ele scurte și ar lăsa un strat neinteractiv peste pagină. */
    const close = () => {
      clearTimeout(closeTimer);
      closeTimer = null;
      notification.hidden = true;
      notification.classList.remove('is-open');
    };

    const startTimer = () => {
      clearTimeout(closeTimer);
      if (timerElement) {
        timerElement.style.animation = 'none';
        void timerElement.offsetWidth;
        timerElement.style.animation = '';
      }
      closeTimer = window.setTimeout(close, AUTO_CLOSE_MS);
    };

    const open = (item, cart, quantityAdded) => {
      if (!item) return;

      const productTitle = item.product_title || item.title || item.name || 'Produs FigurinArt';
      const displayedQuantity = Number(quantityAdded) || Number(item.quantity) || 1;
      const signature = `${item.key || item.id || item.variant_id || productTitle}:${displayedQuantity}`;
      const now = Date.now();
      if (signature === lastSignature && now - lastOpenTime < 700) return;
      lastSignature = signature;
      lastOpenTime = now;

      const variantTitle = item.variant_title || '';
      const showVariant = variantTitle && variantTitle !== 'Default Title';
      const imageUrl = normalizeImageUrl(item.featured_image || item.image || item.featured_media?.preview_image);
      const price = typeof item.final_price === 'number' ? item.final_price : item.price;
      const cartCount = typeof cart?.item_count === 'number' ? cart.item_count : null;

      titleElement.textContent = productTitle;
      quantityElement.textContent = displayedQuantity;
      priceElement.textContent = formatMoney(price);
      totalElement.textContent = cart ? formatMoney(cart.total_price) : '';
      summaryElement.textContent = cartCount === null
        ? 'Produsul a fost adăugat'
        : cartCount === 1 ? 'Ai 1 produs în coș' : `Ai ${cartCount} produse în coș`;

      variantElement.textContent = showVariant ? variantTitle : '';
      variantElement.hidden = !showVariant;

      if (imageUrl) {
        imageElement.src = imageUrl;
        imageElement.alt = productTitle;
        imageElement.hidden = false;
        imageWrap.hidden = false;
        productElement.classList.remove('is-without-image');
      } else {
        imageElement.removeAttribute('src');
        imageElement.hidden = true;
        imageWrap.hidden = true;
        productElement.classList.add('is-without-image');
      }

      setPosition();
      notification.hidden = false;
      notification.classList.remove('is-open');
      void notification.offsetWidth;
      notification.classList.add('is-open');
      startTimer();
    };

    const showFromCartEvent = async (event) => {
      const detail = event.detail || {};
      const data = detail.data || {};
      if (data.didError) return;

      /* Nu afișăm confirmarea pentru schimbări de cantitate făcute în pagina
         coșului. Sunt acceptate doar adăugările din Savor și caruselele custom. */
      if (data.source !== 'product-form-component' && data.source !== 'figurinart-stock-carousel') return;

      const cart = data.cart || await getCart();
      const directItem = getAddedItem(detail.resource || data.product || data.item);
      const item = directItem || findAddedItem(cart, detail.sourceId || data.variantId, data.productId);
      const quantityAdded = data.addedQuantity || (data.source === 'product-form-component' ? data.itemCount : null);

      open(item, cart, quantityAdded);
    };

    document.addEventListener('cart:update', (event) => {
      void showFromCartEvent(event);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !notification.hidden) close();
    });

    window.addEventListener('resize', () => {
      if (!notification.hidden) setPosition();
    }, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        if (!notification.hidden) setPosition();
      }, { passive: true });
    }

    /* Facebook/Instagram pe Android nu sintetizează întotdeauna click după
       atingere. touchend oferă o cale directă, iar click rămâne pentru mouse,
       tastatură și browserele obișnuite. */
    notification.addEventListener('touchend', (event) => {
      const target = event.target.closest?.('[data-fig-cart-close], .fig-cart-notification__cart-link');
      if (!target) return;

      event.preventDefault();
      lastTouchTime = Date.now();

      if (target.matches('[data-fig-cart-close]')) {
        close();
      } else {
        window.location.assign(target.href || cartUrl);
      }
    }, { passive: false });

    notification.addEventListener('click', (event) => {
      const target = event.target.closest?.('[data-fig-cart-close], .fig-cart-notification__cart-link');
      if (!target) return;

      if (Date.now() - lastTouchTime < 700) {
        event.preventDefault();
        return;
      }

      if (target.matches('[data-fig-cart-close]')) {
        event.preventDefault();
        close();
      } else if (target === cartLink) {
        event.preventDefault();
        window.location.assign(cartLink.href || cartUrl);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
